// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CrownOutlinedSvg from "@ant-design/icons-svg/es/asn/CrownOutlined";
import AntdIcon from '../components/AntdIcon';

var CrownOutlined = function CrownOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CrownOutlinedSvg
  }));
};

CrownOutlined.displayName = 'CrownOutlined';
export default React.forwardRef(CrownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CrownOutlined.js
// module id = 893
// module chunks = 0